import React from "react";
import { Link } from "react-router-dom";
import styles from "./NavbarDropdown.module.css";
import { withTranslation } from "react-i18next";
import history from "../../utils/History";
import Utils from "../../utils/Utils";

class NavbarDropdown extends React.Component {
    constructor(props) {
        super(props);
    }

    onClick(url, id) {
        // se siamo in FormHIV chiediamo allo user se vuole cambiare davvero
        const alreadyInTheForm =
            history.location.pathname.startsWith("/formHIV");
        if (alreadyInTheForm) {
            history.push({
                pathname: "/formHIV",
                search: "?redirect=" + url,
            });
        } else {
            if(url.includes("/logout")){
                localStorage.removeItem("state");
                localStorage.removeItem("code_verifier");
                sessionStorage.clear();
            }
            sessionStorage.removeItem("filtriMonitoraggio")
            history.push({ pathname: url , id: id});
        }
    }

    toggleBurgher() {
        if (this.props.toggleHamburger) {
            this.props.toggleHamburger();
        }
    }

    handleFormHIVResetting() {
        // controlla se lo user non è già nel form, se non lo è naviga normalmente
        const alreadyInTheForm =
            history.location.pathname.startsWith("/formHIV");
        history.push({
            pathname: "/formHIV",
            hash: alreadyInTheForm ? "reload" : undefined,
        });
    }

    createDropDown() {
        let elements = this.props.elements;
        let link;
        let links = [];
        const { t } = this.props;
        if (elements) {
            for (let i = 0; i < elements.length; i++) {
                let url = elements[i].url;
                let valoreParametro = elements[i].nomeParametro;
                if (Utils.checkFunzionalitaByRuolo(elements[i].label)) {
                    if (
                        elements[i].url &&
                        elements[i].url.startsWith("/") &&
                        !this.props.notifica
                    ) {
                        // gestisci casistica in cui sei in FormHIV e chiedi di riaprire il form
                        if (elements[i].url === "/formHIV") {
                            link = (
                                <div
                                    key={elements[i].label}
                                    style={{
                                        color: "white",
                                        cursor: "pointer",
                                    }}
                                >
                                    <li
                                        className={[
                                            styles.dropdownItemCustom,
                                            styles.spanCustom,
                                        ]
                                            .join(" ")
                                            .concat("dropdown-item")}
                                        id={elements[i].label}
                                        onClick={() => {
                                            this.handleFormHIVResetting();
                                            this.toggleBurgher();
                                        }}
                                    >
                                        <span className={styles.listItem}>
                                            {t(elements[i].label)}
                                        </span>
                                    </li>
                                </div>
                            );
                        } else {
                            link = (
                                <div
                                    key={elements[i].label}
                                    style={{
                                        color: "white",
                                        cursor: "pointer",
                                    }}
                                >
                                    <li
                                        className={[
                                            styles.dropdownItemCustom,
                                            styles.spanCustom,
                                        ]
                                            .join(" ")
                                            .concat(" dropdown-item")}
                                        id={elements[i].label}
                                        onClick={() => {
                                            this.onClick(url, elements[i].id);
                                            this.toggleBurgher();
                                        }}
                                    >
                                        <span className={styles.listItem}>
                                            {t(elements[i].label)}
                                        </span>
                                    </li>
                                </div>
                            );
                        }
                    } else if (this.props.notifica) {
                        link = (
                            <Link
                                key={elements[i].label}
                                to={{
                                    pathname: elements[i].url,
                                    idSegnalazione: valoreParametro,
                                }}
                                style={{ marginTop: "-100px!important" }}
                            >
                                <div
                                    className={"card"}
                                    style={{ maxHeight: "155px", maxWidth: "300px"}}
                                >
                                    <li
                                        className={[
                                            styles.dropdownItemCustomNotifiche,
                                            styles.spanCustomNotifiche,
                                        ]
                                            .join(" ")
                                            .concat(" dropdown-item")}
                                        id={elements[i].label}
                                        onClick={() => {
                                            this.onClick(url, valoreParametro);
                                            this.toggleBurgher();
                                        }}
                                    >
                                        <div
                                            className="card-body"
                                            style={{ maxHeight: "155px", whiteSpace: "normal"}}
                                        >
                                            <span className="card-title">
                                                {"Id segnalazione: "}
                                            </span>
                                            <span
                                                className="card-title"
                                                style={{ fontWeight: "bold" }}
                                            >
                                                {elements[i].nomeParametro}
                                            </span>
                                            <br></br>
                                            <span className="card-text">
                                                {"Malattia: "}
                                            </span>
                                            <span
                                                className="card-title"
                                                style={{ fontWeight: "bold" }}
                                            >
                                                {JSON.parse(
                                                    sessionStorage.getItem(
                                                        "malattiePerCodice"
                                                    )
                                                )[
                                                    elements[i].malattia
                                                ]?.descrizione}
                                            </span>
                                            <br/>
                                            <span className="card-text">
                                                {"Inserita dall'utente: "}
                                            </span>
                                            <span
                                                className="card-title"
                                                style={{ fontWeight: "bold" }}
                                            >
                                                {elements[
                                                    i
                                                ].utenteInserimento}
                                            </span>
                                            <div
                                                className="card-text"
                                                style={{ fontWeight: "bold" }}
                                            >
                                                {elements[i].label + " giorni rimanenti per la validazione della segnalazione"}
                                            </div>
                                        </div>
                                    </li>
                                </div>
                                {i < elements.length - 1 ? (
                                    <hr/>
                                ) : (
                                    ""
                                )}
                            </Link>
                        );

                        if (i === 3) i = elements.length;
                    } else {
                        link = (
                            <a
                                href={elements[i].url}
                                style={{ color: "white" }}
                                key={elements[i].label}
                            >
                                <li
                                    className={[
                                        styles.dropdownItemCustom,
                                        styles.spanCustom,
                                    ]
                                        .join(" ")
                                        .concat(" dropdown-item")}
                                    id={elements[i].label}
                                    onClick={() => {
                                        this.onClick(url);
                                        this.toggleBurgher();
                                    }}
                                >
                                    <span className={styles.listItem}>
                                        {t(elements[i].label)}
                                    </span>
                                </li>
                            </a>
                        );
                    }
                    links.splice(i, 0, link);
                }
            }
        }
        return links;
    }

    render() {
        return (
            <div>
                <div
                    className={
                        this.props.notifica
                            ? "dropdown-menu"
                                  .concat(" col-lg-2")
                                  .concat(styles.dropdownMenu)
                            : "dropdown-menu"
                    }
                    aria-labelledby="dropdownMenuButton"
                    style={{
                        marginRight: this.props.notifica ? "230px" : "7%",
                    }}
                >
                    <div className="link-list-wrapper">
                        <ul className="link-list">{this.createDropDown()}</ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation("common")(NavbarDropdown);
